import keyMirror from 'keymirror';

export const LiteProjectActionTypes = keyMirror({
  CREATE_LITE_PROJECT_REQUEST: undefined,
  CREATE_LITE_PROJECT_SUCCESS: undefined,
  CREATE_LITE_PROJECT_FAILURE: undefined,
  UPDATE_LITE_PROJECT_REQUEST: undefined,
  UPDATE_LITE_PROJECT_SUCCESS: undefined,
  UPDATE_LITE_PROJECT_FAILURE: undefined,
  FETCH_LITE_BOM_REQUEST: undefined,
  SAVE_USER_PROFILE_REQUEST: undefined,
  SAVE_USER_PROFILE_SUCCESS: undefined,
  SAVE_USER_PROFILE_FAILURE: undefined,
  UPDATE_USER_PROFILE_REQUEST: undefined,
  UPDATE_USER_PROFILE_SUCCESS: undefined,
  UPDATE_USER_PROFILE_FAILURE: undefined,
  DELETE_USER_PROFILE_REQUEST: undefined,
  DELETE_USER_PROFILE_SUCCESS: undefined,
  DELETE_USER_PROFILE_FAILURE: undefined,
  FETCH_PROJECT_VARIABLES_REQUEST: undefined,
  FETCH_PROJECT_VARIABLES_SUCCESS: undefined,
  FETCH_PROJECT_VARIABLES_FAILURE: undefined,
  FETCH_USER_PROFILES_REQUEST: undefined,
  FETCH_USER_PROFILES_SUCCESS: undefined,
  FETCH_USER_PROFILES_FAILURE: undefined,
  SAVE_LITE_BOM_REQUEST: undefined,
  SAVE_LITE_BOM_SUCCESS: undefined,
  SAVE_LITE_BOM_FAILURE: undefined,
});
